export default "__VITE_ASSET__BCSjNueT__"